var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 24,
    viewBox: "0 0 33 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3131 -0.000243298C20.3071 -0.000625786 19.3052 0.129202 18.3325 0.386006C20.9033 0.922051 23.2179 2.31021 24.9014 4.32568C26.585 6.34114 27.5389 8.8659 27.6086 11.4911C27.6784 14.1162 26.86 16.6881 25.2859 18.7902C23.7118 20.8922 21.4742 22.4014 18.9355 23.0732C19.8816 23.2696 20.8484 23.3477 21.8137 23.3058C27.9897 23.0456 32.9213 17.9347 32.9706 11.7538C32.9833 10.2148 32.6912 8.6885 32.1111 7.26299C31.5309 5.83748 30.6743 4.54095 29.5905 3.44821C28.5068 2.35547 27.2173 1.48814 25.7967 0.896271C24.376 0.304401 22.8522 -0.000296098 21.3131 -0.000243298Z",
    fill: "url(#paint0_linear_4724_16037)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6192 11.8013C27.619 9.12184 26.696 6.5242 25.0056 4.44528C23.3152 2.36637 20.9604 0.932986 18.3374 0.38623C15.7987 1.05809 13.5611 2.56724 11.987 4.6693C10.4129 6.77135 9.5945 9.34321 9.66428 11.9684C9.73405 14.5936 10.6879 17.1183 12.3715 19.1338C14.055 21.1492 16.3696 22.5374 18.9404 23.0734C21.428 22.4155 23.6282 20.9531 25.198 18.9142C26.7678 16.8753 27.6191 14.3745 27.6192 11.8013Z",
    fill: "url(#paint1_linear_4724_16037)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9375 23.0732C16.3667 22.5372 14.0521 21.149 12.3685 19.1335C10.685 17.1181 9.73112 14.5933 9.66134 11.9681C9.59156 9.34297 10.41 6.7711 11.9841 4.66905C13.5582 2.56699 15.7957 1.05784 18.3344 0.385983C16.2524 -0.0455919 13.9694 0.073632 11.6342 0.929883C10.1317 1.4835 8.76753 2.35699 7.63598 3.4899C6.50444 4.62281 5.63258 5.98807 5.08077 7.49119C3.96045 10.5516 4.1053 13.5234 5.10442 16.0636L5.09851 16.0577L0.544315 23.556C0.52997 23.5796 0.522917 23.6069 0.524042 23.6345C0.525168 23.662 0.534422 23.6887 0.550641 23.711C0.566859 23.7333 0.589319 23.7503 0.615193 23.7599C0.641067 23.7695 0.669201 23.7713 0.696056 23.7649L9.69113 21.6307C11.0488 22.4962 12.571 23.0712 14.1619 23.3193C15.7528 23.5674 17.3778 23.4832 18.9345 23.0722L18.9375 23.0732Z",
    fill: "url(#paint2_linear_4724_16037)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4724_16037",
    x1: 41.204,
    y1: 11.9695,
    x2: 4.15855,
    y2: 11.3902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AFCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D7791"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4724_16037",
    x1: 18.4694,
    y1: 5.87353,
    x2: 18.903,
    y2: 21.0683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21A5BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1CA0A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4724_16037",
    x1: 7.58154,
    y1: 27.2894,
    x2: 18.0497,
    y2: -1.0861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AFCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D7791"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logoIcon.78ff2f312be74d6a85559d00159dfd49.svg";
export { ForwardRef as ReactComponent };